import posthog from 'posthog-js';

import type { SubsctiptionEvent } from 'features/billing/lib/constants';
import type { DashboardEvent } from 'features/dashboard/lib/constants';
import type { NotificationEvent } from 'features/notifications/lib/constants';
import type { UpgradePromoEvent } from 'features/upgradePromo/lib/constants';
import type { VerificationEvent } from 'features/verification/lib/constants';

export type TrackEventProperties = Record<string, unknown> | undefined;

export type TrackOptions = {
  ga?: boolean;
};

export type TrackEvent = VerificationEvent | SubsctiptionEvent | DashboardEvent | NotificationEvent | UpgradePromoEvent;

export const trackEvent = (event: TrackEvent, props?: TrackEventProperties, options?: TrackOptions): void => {
  posthog.capture(event, props);

  const { ga = false } = options ?? {};

  if (ga && gtag) {
    gtag('event', event, props ?? {});
  }
};
